import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a33217614f1f200149f0148_1781738532343_a3c2b4b1/coffeebay/src/app/page.tsx");
